import AnalyticsIcon from '@mui/icons-material/Analytics';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { Tooltip } from '@mui/material';
import { FunctionComponent } from 'react';
import { AccessibleButton } from '../../components/Accessibility';
import { NavButton } from '../../components/Buttons';
import { NarrowAdminLayout } from '../../components/layout/AdminLayout';
import { gaPropertyId } from '../../config/Firebase';
import { Environment } from '../../util/Environment';

export const AdminScreen: FunctionComponent = () => {
	return <NarrowAdminLayout title='Admin'>
		<NavButton title='Manage Questions' route='/admin/questions' startIcon={<FormatListBulletedIcon />} />
		<NavButton title='Manage Question Sets' route='/admin/question-sets' startIcon={<ViewCarouselIcon />} />
		<AnalyticsButton />
	</NarrowAdminLayout>;
};

const AnalyticsButton: FunctionComponent = () => {
	function openGoogleAnalytics() {
		const url = `https://analytics.google.com/analytics/web/#/p${gaPropertyId}/reports/intelligenthome`;
		window.open(url, '_blank');
	}

	return <Tooltip title={`Open Google Analytics. For access contact ${Environment.supportEmail}.`}>
		<AccessibleButton variant="contained" size="large" onClick={openGoogleAnalytics} startIcon={<AnalyticsIcon />}>
			Analytics
		</AccessibleButton>
	</Tooltip >;
};